/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostVideoMultiPartUploadSignedurl200ResponsePartsInner
 */
export interface PostVideoMultiPartUploadSignedurl200ResponsePartsInner {
    /**
     * 
     * @type {number}
     * @memberof PostVideoMultiPartUploadSignedurl200ResponsePartsInner
     */
    partNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PostVideoMultiPartUploadSignedurl200ResponsePartsInner
     */
    signedUrl?: string;
}

/**
 * Check if a given object implements the PostVideoMultiPartUploadSignedurl200ResponsePartsInner interface.
 */
export function instanceOfPostVideoMultiPartUploadSignedurl200ResponsePartsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSON(json: any): PostVideoMultiPartUploadSignedurl200ResponsePartsInner {
    return PostVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSONTyped(json, false);
}

export function PostVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostVideoMultiPartUploadSignedurl200ResponsePartsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partNumber': !exists(json, 'partNumber') ? undefined : json['partNumber'],
        'signedUrl': !exists(json, 'signedUrl') ? undefined : json['signedUrl'],
    };
}

export function PostVideoMultiPartUploadSignedurl200ResponsePartsInnerToJSON(value?: PostVideoMultiPartUploadSignedurl200ResponsePartsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partNumber': value.partNumber,
        'signedUrl': value.signedUrl,
    };
}

